<template>
    <div class="cB">
        <div class="outer">
            <div class="main" v-for="(item, index) in centerBLeftData" :key="index">
                <div class="m-item ">
                    <p class="title">{{ item.name }}</p>

                    <div class="progress-bar">
                        <div class="bar"></div>
                        <div class="progress" style="width: 32%;"></div>
                    </div>
                    <span class="num">{{ item.num1 }}</span>
                    <span class="unit">{{ item.unit }}</span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'template.centerB-L-temp3',
    data() {
        return {
            centerBLeftData: [
                { name: "中小学校园数量", val: "mu", num1: '21', unit: "人" },
                { name: "中小学教师数量", val: "mu", num1: '2560', unit: "人" },

            ]

        }
    },
    mounted() {

    },
    watch: {
    },
    methods: {

    },
    beforeDestroy() {

    },
}
</script>

<style scoped lang="scss">
@font-face {
    font-family: "YeJinShuZi";
    src: url("../../assets/fonts/YeJinShuZi.woff2");
}

.cB {
    width: 435px;
    height: 240px;

    padding: 10px 0;
}

.outer {
    width: 435px;
    height: 240px;
    position: relative;

    z-index: 1;
}

.main {
    width: 360px;
    margin: 16px auto;
   

}

.m-item {
    position: relative;
    margin:20px 0 40px;
    // padding: 12px 0 0 10px;
    .title {

        font-family: Source Han Sans CN;
        // font-weight: 400;
        font-size: 14px;
        color: #e3e4e6;
        margin-bottom: 6px;
        position: relative;

    }

    .title::after {
        content: "";
        width: 18px;
        height: 18px;
        background: url('../../assets/template3/sanjiao.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: -20px;
        top: 0px;

    }

    .num {

        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        margin: 0 4px 0 0;
        position: absolute;
        right: 30px;
        top: 0;

    }

    .unit {
        width: 24px;
        height: 11px;
        // font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #CBCBCB;
        position: absolute;
        right: 0;
        top: 0;
    }
}

.progress-bar {
    width: 360px;
    background: #26303D;
    border-radius: 4px;
    overflow: hidden;
}

.progress {
    background: #35D2D1;
    background: linear-gradient(90deg, #26303D, #35D2D1 60%);
    height: 6px;
    border-radius: 4px;
    position: relative;
    transition: width 0.5s ease;
}

.bar {
    content: "";
    width: 8px;
    height: 8px;
    background: #fff;

    border-radius: 50%;
    position: absolute;
    top: 25px;
    left: 105px;
    z-index: 10;
}

.bar::before {
    content: "";
    width: 12px;
    height: 12px;
    border-radius: 50%;
    position: absolute;
    top: -4px;
    left: -4px;
    z-index: 10;
    border: 2px solid #234451;
}

/* 可选: 为进度条添加动画效果 */
.progress.animate {
    width: 100%;
    animation: progress-bar-stripes 2s linear infinite;
}

@keyframes progress-bar-stripes {
    from {
        background-size: 40px 40px;
    }

    to {
        background-size: 40px 0;
    }
}
</style>